<div class="sched-job-modal-container">
  <div class="overlay"></div>
  <div class="sched-job-modal" [ngClass]="modalSizeClass">
    <div class="sched-job-modal__close-container">
      <prism-button
        (clicked)="handleClose()"
        class="close-button"
        icon="close"
        type="transparent-dark"
      ></prism-button>
    </div>
    <div class="sched-job-modal__container">
      <header class="sched-job-modal__container__header">
        <div class="sched-job-modal__container__header__title">
          <h2>{{ modalTitle }}</h2>
        </div>
        <span class="sched-job-modal__container__header__sub-title">
          <p>{{ modalMessage }}</p>
          <p>{{ modalSubTitle }}</p>
        </span>
      </header>
      <main class="sched-job-modal__container__content">
        <mat-icon class="sched-job-modal__container__content__icon" svgIcon="p-icon-gem-fade"></mat-icon>
        <kendo-stepper
          #stepper
          stepType="full"
          [currentStep]="currentStep"
          [linear]="false"
          [steps]="steps"
        ></kendo-stepper>
        <div *ngIf="isJobRunning || isJobPending" class="sched-job-modal__container__content__loader">
           <prism-dot-orbit-loader></prism-dot-orbit-loader>
        </div>
        <div *ngIf="!isJobRunning && !isJobPending" class="sched-job-modal__container__content__results">
          <div class="sched-job-modal__container__content__results-header">
            <span class="sched-job-modal__container__content__results-header-label">JOB ID:</span>
            <span class="sched-job-modal__container__content__results-header-value">{{ jobId }}</span>
          </div>
          <div class="sched-job-modal__container__content__results-content">
            <ng-container *ngIf="isJobFailed; else jobSucceeded">
              <ng-container *ngIf="job?.jobDetails?.errors?.length; else scheduledJobStatusModalNoResults">
                <ng-container *ngTemplateOutlet="scheduledJobStatusModalFailedResults"></ng-container>
              </ng-container>
            </ng-container>
            <ng-template #jobSucceeded>
              <ng-container *ngIf="job?.jobDetails?.outputParams?.length; else scheduledJobStatusModalNoResults">
                <ng-container *ngTemplateOutlet="scheduledJobStatusModalSuccessfulResults"></ng-container>
              </ng-container>
            </ng-template>
          </div>
        </div>
      </main>
      <footer class="sched-job-modal__container__footer">
        <prism-button
          *ngIf="isJobPending"
          (clicked)="cancelJob()"
          class="primary-button"
          icon="close"
          type="cancel"
        >
          Cancel {{ jobType }}
        </prism-button>
        <prism-button (clicked)="navigateToScheduledJobs()" class="secondary-button" type="primary">Scheduled Jobs</prism-button>
        <prism-button (clicked)="handleClose()" class="secondary-button" type="primary">Close Window ({{ jobType }} {{ jobCompletionStatus}})</prism-button>
      </footer>
    </div>
  </div>
</div>

<ng-template #scheduledJobStatusModalFailedResults>
  <div *ngFor="let error of job?.jobDetails?.errors" class="sched-job-modal__container__content__results-content-item">
    <span>{{ error }}</span>
  </div>
</ng-template>

<ng-template #scheduledJobStatusModalSuccessfulResults>
  <ng-container *ngFor="let outputParam of job?.jobDetails?.outputParams">
  <div *ngIf="outputParam.type === 'U'"  class="sched-job-modal__container__content__results-content-item">
    <prism-scheduler-file-download
      [docId]="outputParam.value"
      [jobId]="jobId"
    ></prism-scheduler-file-download>
  </div>
  </ng-container>
</ng-template>

<ng-template #scheduledJobStatusModalNoResults>
  <div class="sched-job-modal__container__content__results-content-item">
    <span>No results to display.</span>
  </div>
</ng-template>